

import {
    Alert,
    Button,
    Card,
    Col,
    Form,
    Input,
    // message,
    Row,
    Spin,
    Typography,
} from "antd";
import React, { Fragment, useState } from "react";
//   import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import { useAuthContext } from "../../context/AuthContext";
import useScreenSize from "../../hooks/useScreenSize";
// import { API } from "../../constant";
// import { setToken } from "../../helpers";
import  axios  from "axios";


const Forgot = () => {
    const { isDesktopView } = useScreenSize();
    // const navigate = useNavigate();

    // const { setUser } = useAuthContext();

    const [isLoading, setIsLoading] = useState(false);

    const [error, setError] = useState("");

    const onFinish = async (values) => {
        setIsLoading(true);
        try {
            const value = {
                email: values.email,

            };
            console.log(value);
            axios
                .post(
                    "http://localhost:1337/api/auth/forgot-password",
                    value,
                    {
                        headers: {
                            Authorization:
                                "Bearer 99862a8705c3896186703477347410eac99889bbacd6c8a9b2d2047612a1d048496c1f77a7368f987e155bf842e2c3f405934a36b4ca228d4d4dc6c6e01e89ae0ccee22dd3c76534528f11a3d4dd4728611ad97b077d7ff05a30a46bc9ffa653f90de5c61a13147f3c5f0e7114243d3df211cfae5d8e551a98475e76902f52e9",
                        },
                    }
                ).then((response) => {
                    // Handle success.
                    console.log(response);
                    console.log(value);
                })
                .catch((error) => {
                    // Handle error.
                    console.log("An error occurred:", error.response);
                    console.log(value);
                });
        }
    
       
  
        // const data = await response.json();
        // if (data?.error) {
        //     throw data?.error;
        // } else {
        //     // set the token
        //     setToken(data.jwt);

        //     // set the user
        //     setUser(data.user);

        //     message.success(`Welcome back ${data.user.username}!`);

        //     navigate("/dashboard", { replace: true });
        // }
    // }
     catch (error) {
        console.error(error);
        setError(error?.message ?? "Something went wrong!");
    } finally {
        setIsLoading(false);
    }
};


// const emailInputRefs = useRef();
// async function forgot_Password(e) {
//     e.preventDefault();

//     const isValid = await form.validate(e);
//     const enteredEmail = emailInputRefs.current.value;
//     let data = {
//         email: enteredEmail,
//     };

//     console.log(data);
//     if (isValid) {


//         axios
//             .post(
//                 "https://strapi-movie-app.onrender.com/api/auth/forgot-password",
//                 data,
//                 {
//                     headers: {
//                         Authorization:
//                             "Bearer c03f2ff3dc732f216fff5ab4e4766d1fc88b820752ff5cc25d47cb4e5e867b67e01f3748cf3d6de665bad7c22f2c995d3f549073874e893ac037685ed2081be326647aac58ae737ccee9dde8d36d56c36f84fe34ecd6e2b42b27dff6662b6e959f420b117d0c3cddcdcf45263bfe82dc75fb854690842ed01bb88f960226d62e",
//                     },
//                 }
//             )
//             .then((response) => {
//                 // Handle success.
//                 console.log(response);
//             })
//             .catch((error) => {
//                 // Handle error.
//                 console.log("An error occurred:", error.response);
//             });
//     }

//     e.target.reset();
// };


return (
    <Fragment >
        <Row align="middle">
            <Col className="card" span={isDesktopView ? 8 : 24} offset={isDesktopView ? 8 : 0}>
                <Card className="test" title="Forgot Password" >
                    {error ? (
                        <Alert
                            className="alert_error"
                            message={error}
                            type="error"
                            closable
                            afterClose={() => setError("")}
                        />
                    ) : null}
                    <Form
                        name="basic"
                        layout="vertical"
                        onFinish={onFinish}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    type: "email",
                                },
                            ]}
                        >
                            <Input placeholder="Email address" />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="login_submit_btn"
                            >
                                Submit {isLoading && <Spin size="small" />}
                            </Button>
                        </Form.Item>
                    </Form>
                    <Typography.Paragraph className="form_help_text">
                        {/* Don't have an account? <Link to="/signup">Sign Up</Link> */}
                    </Typography.Paragraph>
                </Card>
            </Col>
        </Row>
    </Fragment>
);
  };

export default Forgot;